import { render, staticRenderFns } from "./DropArea.vue?vue&type=template&id=50db76d9&scoped=true"
import script from "./DropArea.vue?vue&type=script&lang=js"
export * from "./DropArea.vue?vue&type=script&lang=js"
import style0 from "./DropArea.vue?vue&type=style&index=0&id=50db76d9&prod&lang=scss&scoped=true"
import style1 from "./DropArea.vue?vue&type=style&index=1&id=50db76d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50db76d9",
  null
  
)

export default component.exports